import styled from 'styled-components';
import { navMenuDatasetItems } from '../../../desktop-header/items/nav-menu/data';
import { Item, ItemLink, MenuTitleSmall } from '../../shared-menus';

export const DataBlock = () => {
  return (
    <Root>
      <MenuTitleSmall>Data</MenuTitleSmall>
      {[...navMenuDatasetItems].map(item => (
        <Item key={item.id}>
          <ItemLink to={item.url}>{item.linkText}</ItemLink>
        </Item>
      ))}
    </Root>
  );
};

const Root = styled.div``;
